import styled, { css } from 'styled-components';

const animationStyles = css`
    svg {
        animation: popUpIcon 0.75s cubic-bezier(0.4, 0, 0.2, 1), rotateIcon 0.9s cubic-bezier(0.4, 0, 0.2, 1) 0.75s;
        transform-origin: bottom;
    }

    // Анимация полностью скопирована из Google Meet
    @keyframes popUpIcon {
        0% {
            transform: translateY(24px);
        }
        22% {
            transform: translateY(24px);
        }
        48.93% {
            transform: translateY(-5px);
        }
        100% {
            transform: translateY(0);
        }
    }

    @keyframes rotateIcon {
        20.33% {
            transform: rotate(14deg);
        }
        38.89% {
            transform: rotate(-9deg);
        }
        57.44% {
            transform: rotate(14deg);
        }
        74.11% {
            transform: rotate(-9deg);
        }
        88.89% {
            transform: rotate(5deg);
        }
        0% {
            transform: rotate(0deg);
        }
    }
`;

export const RaiseHandIconWrapper = styled.div<{ $size?: number }>`
    box-sizing: border-box;
    background: ${(props) => props.theme.root.colors.basicColors['80%']};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${(props) => (props.$size === 16 ? '24px' : 'auto')};
    height: ${(props) => (props.$size === 16 ? '24px' : 'auto')};
    padding: 4px;
    overflow: hidden;
    flex-shrink: 0;

    --ic-hand-up-color: ${(props) => props.theme.root.colors.basicColors.black['95%']};

    ${animationStyles}
`;

export const RaiseHandListIconWrapper = styled.div`
    --ic-hand-up-color: ${(props) => props.theme.root.colors.system.warningDefault};

    ${animationStyles}
`;
